<template>
  <v-app v-if="!$route.meta.anonymousAuth && ['/'].indexOf($route.path) < 0">
    <core-toolbar color="secondary">
      <template slot="toolbar-avatar">
        <v-avatar style="cursor: pointer" @click="gotoHome" max-height="50px" size="100" class="ml-3" tile>
          <ImagemComFallback
            :src="logo"
            srcDefault="/assets/imgs/logo.svg"
            height="100%"
            width="100%"
            contain
            data-cy="toolbar-img"
          />
        </v-avatar>
      </template>

      <template slot="toolbar-title">
        &nbsp;
      </template>
      <template slot="toolbar-drawer">
        &nbsp;
      </template>
    </core-toolbar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <slot name="footer">
      <v-footer inset app>
        <v-row class="justify-center">
          <span class="px-4">&copy; {{ new Date().getFullYear() }} - Money Plus</span>
        </v-row>
      </v-footer>
    </slot>
  </v-app>
  <IndexLayout v-else></IndexLayout>
</template>

<script>
export default {
  data () {
    return {
      logo: this.$theme.logo || '/assets/imgs/logo.svg',
    }
  },
  components: {
    IndexLayout: () => import('@bmp-vue/core/layouts/IndexLayout')
  },
  methods: {
    gotoHome () {
      this.$router.goToHome(this.$route.path)
    }
  }
}
</script>

<style lang="sass">
@import 'assets/styles/styles.scss'
</style>
